import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";

import {
  API_URL,
  getMediaUrl
} from "./config/api";

function WriterPage() {

    const { writerName } = useParams();

    const [articles, setArticles] =
        useState([]);

    const [loading, setLoading] =
        useState(true);


    useEffect(() => {

        const fetchWriterArticles = async () => {

            try {

                const res = await axios.get(
                    `${API_URL}/api/writers/${encodeURIComponent(writerName)}`
                );

                setArticles(res.data);

            } catch (error) {

                console.error(
                    "Error fetching writer articles:",
                    error
                );

            } finally {

                setLoading(false);

            }

        };

        fetchWriterArticles();

    }, [writerName]);


    return (

        <main className="category-page writer-page">

            <div className="writer-main-layout">

                <section className="writer-posts-section">

                    <h1>{writerName}</h1>

                    <p>
                        Articles written by {writerName}
                    </p>

                    <br />

                    {loading ? (

                        <p>
                            Loading articles...
                        </p>

                    ) : articles.length === 0 ? (

                        <p>
                            No articles found for this writer.
                        </p>

                    ) : (

                        <div className="writer-posts-grid">

                            {articles.map((post) => {

                                const imageSrc =
                                    post.coverImage
                                        ? getMediaUrl(post.coverImage)
                                        : post.image
                                            ? getMediaUrl(post.image)
                                            : null;


                                return (

                                    <Link
                                        key={post._id}
                                        to={`/post/${post._id}`}
                                        className="category-post-link"
                                    >

                                        <div
                                            className={`category-post-card ${
                                                imageSrc
                                                    ? "has-image"
                                                    : "no-image"
                                            }`}
                                            style={
                                                imageSrc
                                                    ? {
                                                        backgroundImage:
                                                            `url(${imageSrc})`
                                                    }
                                                    : {}
                                            }
                                        >

                                            <div className="category-post-overlay">

                                                <small>

                                                    Articles

                                                    {post.subcategory && (
                                                        <>
                                                            {" / "}
                                                            {post.subcategory}
                                                        </>
                                                    )}

                                                </small>


                                                <h2>

                                                    {post.title.length > 60
                                                        ? post.title.substring(0, 60) + "..."
                                                        : post.title}

                                                </h2>


                                                <small>
                                                    {post.publishDate}
                                                </small>


                                                <br />


                                                <span className="read-more-button">

                                                    Read More

                                                </span>

                                            </div>

                                        </div>

                                    </Link>

                                );

                            })}

                        </div>

                    )}

                </section>

            </div>

        </main>

    );

}

export default WriterPage;